import React from "react";
import { Dropbox, Droplet, Upload } from "react-bootstrap-icons";
import { useDrop } from "react-dnd";

const DropAreaDuties = ({ group, addField, date }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "FORM_FIELD",
    drop: (item) => addField(item.fieldInput, group, date),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={drop}
      style={{
        border: "1px solid #f0f0f0",
        backgroundColor: isOver ? "#fff" : "#f0f0f0",
        textAlign: 'center',
        padding: '5px 0px 5px 0px',
        marginTop: "5px",
        marginBottom: "5px"
      }}
    >
      <Upload
        style={{
          color: "#454444",
          width: "15px",
          height: "15px"
        }}
      />
    </div>
  );
};

export default DropAreaDuties;
